import { useEffect, useState } from "react";
import { ImagePlus, X } from "lucide-react";
import { api, fileUrl } from "../../lib/api";

export const DesignPicker = ({ value, onChange, files, setFiles }) => {
  const [designs, setDesigns] = useState([]);
  useEffect(() => { api.get("/shop/designs").then((r) => setDesigns(r.data)).catch(() => {}); }, []);
  const mode = value.mode || (designs.length ? "pick" : "own");
  return (
    <div data-testid="design-picker">
      {designs.length > 0 && (
        <div className="mb-4 flex gap-1 rounded-full bg-[#FFF4F8] p-1">
          {[["pick", "Pick a design"], ["own", "Describe my own"]].map(([m, l]) => (
            <button type="button" key={m} onClick={() => onChange({ ...value, mode: m })} data-testid={`design-mode-${m}`}
              className={`flex-1 rounded-full py-2 text-sm font-semibold ${mode === m ? "bg-[#0E0B0D] text-white" : "text-black/60"}`}>{l}</button>
          ))}
        </div>
      )}
      {mode === "pick" ? (
        <div className="grid grid-cols-3 gap-3 sm:grid-cols-4" data-testid="design-grid">
          {designs.map((d) => (
            <button type="button" key={d.id} onClick={() => onChange({ ...value, mode, pick: d.name })} data-testid={`design-${d.id}`}
              className={`overflow-hidden rounded-xl bg-white text-left ring-1 ${value.pick === d.name ? "ring-2 ring-[#FF1F8E]" : "ring-[#EBD08A]"}`}>
              <img src={fileUrl(d.storage_path)} alt={d.name} className="aspect-square w-full object-cover" />
              <p className="truncate px-2 py-1.5 text-xs font-semibold">{d.name}</p>
            </button>
          ))}
        </div>
      ) : (
        <>
          <textarea rows={3} value={value.text || ""} onChange={(e) => onChange({ ...value, mode, text: e.target.value })} maxLength={1200}
            placeholder="Wording, fonts, colors, placement… tell us everything!" className="w-full rounded-xl border border-[#EBD08A] px-4 py-3 outline-none focus:border-[#FF1F8E]" data-testid="design-own-text" />
          <div className="mt-3 flex flex-wrap gap-3">
            {files.map((f, i) => (
              <div key={i} className="relative h-20 w-20 overflow-hidden rounded-xl ring-1 ring-[#EBD08A]">
                <img src={URL.createObjectURL(f)} alt="" className="h-full w-full object-cover" />
                <button type="button" onClick={() => setFiles(files.filter((_, j) => j !== i))} className="absolute right-1 top-1 rounded-full bg-black/70 p-1 text-white"><X className="h-3 w-3" /></button>
              </div>
            ))}
            {files.length < 3 && (
              <label className="grid h-20 w-20 cursor-pointer place-items-center rounded-xl border-2 border-dashed border-[#D4A537] text-[#D4A537]" data-testid="design-image-add">
                <ImagePlus className="h-5 w-5" />
                <input type="file" accept="image/*" multiple className="hidden" onChange={(e) => { setFiles([...files, ...Array.from(e.target.files || [])].slice(0, 3)); e.target.value = ""; }} data-testid="design-image-input" />
              </label>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export const designText = (v, hasDesigns) => ((v.mode || (hasDesigns ? "pick" : "own")) === "pick" ? (v.pick ? `Design: ${v.pick}` : "") : (v.text || "").trim());
